module.exports = __webpack_public_path__ + "images/signal_4.5a8dbf9df14ee57763d46d322cb93a74.png";